module.exports = __webpack_public_path__ + "static/img/business-creative-dev.3f0ae48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business-creative-dev.jpg
// module id = DLtI
// module chunks = 1